app.controller("EditRoleController", ["$scope", "$uibModalInstance", "role", "usSpinnerService", "Access", "DocumentsService",
    function ($scope, $uibModalInstance, role, usSpinnerService, Access, DocumentsService) {
        $scope.role = role;
        $scope.rights = [];
        $scope.documentTypes = [];
        $scope.name = role.name;
        $scope.type = role.type;
        $scope.roleRights = role.rights || [];
        $scope.roleDocumentTypes = role.documentTypes || [];
        var rightsList, documentTypesList = [];

        function hasRight(rightId) {
            return $scope.roleRights.indexOf(rightId) >= 0;
        }

        function hasDocumentType(typeId) {
            return $scope.roleDocumentTypes.indexOf(typeId) >= 0;
        }

        function reloadRights() {
            $scope.rights = [];
            rightsList.forEach(function (item) {
                $scope.rights.push({
                    _id: item._id,
                    name: item.name,
                    enabled: hasRight(item._id)
                });
            });
        }

        function reloadDocumentTypes() {
            $scope.documentTypes = [];
            documentTypesList.forEach(function (item) {
                $scope.documentTypes.push({
                    _id: item._id,
                    name: item.name,
                    enabled: hasDocumentType(item._id)
                });
            });
        }

        function fetchRightsList() {
            usSpinnerService.spin("root");
            Access.fetchPermissionList(role.type).then(function (rights) {
                rightsList = rights;
                reloadRights();
                usSpinnerService.stop("root");
            });
        }

        function fetchDocumentTypesList() {
            usSpinnerService.spin("root");
            DocumentsService.typeList({admin:true}).then(function (documentTypes) {
                documentTypesList = documentTypes;
                reloadDocumentTypes();
                usSpinnerService.stop("root");
            });
        }

        fetchRightsList();
        fetchDocumentTypesList();

        $scope.update = function () {
            if (!($scope.role.name.length && $scope.role.description.length)) {
                return;
            }
            Access.updateRole($scope.role).then(function () {
                $uibModalInstance.close();
            });
        };

        $scope.toggle = function(right){
            if(!right.enabled){
                $scope.assign(right._id);
            }
            else {
                $scope.revoke(right._id);
            }
        };

        $scope.assign = function (rightId) {
            Access.roleAssignRight({rightId: rightId, roleId: role._id}).then(function (role) {
                $scope.roleRights = role.rights;
                reloadRights();
            });
        };

        $scope.revoke = function (rightId) {
            Access.roleRevokeRight({rightId: rightId, roleId: role._id}).then(function (role) {
                $scope.roleRights = role.rights;
                reloadRights();
            });
        };

        $scope.toggleDocType = function(documentType){
            if(!documentType.enabled){
                $scope.assignDocType(documentType._id);
            }
            else {
                $scope.revokeDocType(documentType._id);
            }
        };

        $scope.assignDocType = function (typeId) {
            Access.AssignDocumentType({roleId: role._id, documentTypeId: typeId}).then(function (role) {
                $scope.roleDocumentTypes = role.documentTypes;
                reloadDocumentTypes();
            });
        };

        $scope.revokeDocType = function (typeId) {
            Access.RevokeDocumentType({roleId: role._id, documentTypeId: typeId}).then(function (role) {
                $scope.roleDocumentTypes = role.documentTypes;
                reloadDocumentTypes();
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };
    }
]);
